import { API_URL } from "../../constants";
import { axiosInstance } from "../_base/axios.instance";

export async function getPost({ postId }){
    const response = await axiosInstance.get(
        `${API_URL}/posts/getPost/${postId}`
    );
    return response;
} ;
